// El ícono de cada tipo de toma (un set cerrado, como `ICONO_NODO` en Flujos). El agente elige
// uno de `ICONOS_DE_TOMA`; fuera del set cae en `otro`.
import {
  ArrowDownToLine,
  DoorOpen,
  LayoutGrid,
  Layers,
  Package,
  PanelLeft,
  Ruler,
  Sofa,
  Sparkles,
  Square,
  User,
  ZoomIn,
  type LucideIcon,
} from 'lucide-react';
import type { IconoDeToma } from './plan';

export const ICONO_DE_TOMA: Record<IconoDeToma, LucideIcon> = {
  packshot: Package,
  ambiente: Sofa,
  detalle: ZoomIn,
  medidas: Ruler,
  'en-uso': User,
  conjunto: LayoutGrid,
  frente: Square,
  lateral: PanelLeft,
  superior: ArrowDownToLine,
  materiales: Layers,
  abierto: DoorOpen,
  otro: Sparkles,
};
